function a(a,e,f,i){a._m(e),a.o(e,"PageHeaderTitle",()=>a.f(d));var d=a.i(f("8faf66d5"));}